import {
  styled,
  generateUtilityClasses,
  SwipeableDrawer as Drawer,
  Dialog,
} from '@tino-frontend/coreui'
import { FloatClass } from './float.classes'

const floatClasses: FloatClass = generateUtilityClasses('TrueFloat', [
  'action',
  'children',
  'open',
  'close',
  'paper',
])

export const DrawerRoot = styled(Drawer, {
  shouldForwardProp: (p) =>
    !['disablePadding', 'maxHeight', 'backgroundColor'].includes(p as string),
})<{
  maxHeight?: number
  disablePadding?: boolean
  backgroundColor?: string
}>(({ theme, maxHeight, disablePadding, backgroundColor }) => {
  return {
    zIndex: theme.zIndex.modal,
    '& .MuiDrawer-paper': {
      padding: disablePadding ? 0 : theme.spacing(4),
      borderRadius: 0,
      maxHeight,
      background: backgroundColor || theme.palette.common.white,
    },
    [`& .${floatClasses.action}`]: {
      position: 'absolute',
      right: theme.spacing(2),
      top: theme.spacing(2),
    },
    [`& .${floatClasses.children}`]: {
      height: '100%',
    },
  }
})

export const DrawerHandleRoot = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '8px',
  left: '50%',
  transform: 'translateX(-50%)',

  width: '64px',
  height: '2px',
  borderRadius: theme.shape.borderRadius,
  background: theme.palette.divider,
}))

export const DialogRoot = styled(Dialog, {
  shouldForwardProp: (p) => !['disablePadding'].includes(p as string),
})<{ disablePadding?: boolean }>(({ theme, disablePadding }) => {
  return {
    [`& .${floatClasses.paper}`]: {
      padding: disablePadding ? 0 : theme.spacing(4),
      [theme.breakpoints.up('md')]: {
        minWidth: '450px',
      },
    },
    [`& .${floatClasses.action}`]: {
      position: 'absolute',
      right: theme.spacing(2),
      top: theme.spacing(2),
    },
    [`& .${floatClasses.children}`]: {
      '& .TrueButton-root': {
        width: '100%',
      },
    },
  }
})
